import { memo, useEffect } from 'react';
import { ItalianState } from 'mutation/view-models/registration-citizenship';
import { Grid, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import MunicipalityListFilterDate, {
  MunicipalityAnprVM,
} from 'shell/components/shared/municipality-list';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { DateTime } from 'luxon';

interface OpenLegisProps {
  values?: ItalianState;
  onChange: (key: keyof ItalianState, value: ItalianState[keyof ItalianState]) => void;
  onChanges?: (value?: ItalianState) => void;
  dateFilter?: DateTime | null;
  disabled?: boolean;
  required?: boolean;
}

const ItalianComponent = ({
  onChange,
  onChanges,
  values,
  dateFilter,
  disabled,
  required,
}: OpenLegisProps): React.ReactElement => {
  const onChangeMunicipalityList = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    onChange('municipality', municipality);
  });

  useEffect(() => {
    // reset municipality
    if (onChanges) {
      onChanges(undefined);
    }
    onChange('municipality', null);
  }, [dateFilter]);

  return (
    <Grid
      item
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={{ xs: 1, md: 0 }}
      xs={12}
    >
      <Grid item xs={12} md={6}>
        {dateFilter ? (
          <MunicipalityListFilterDate
            value={values?.municipality || null}
            onChange={onChangeMunicipalityList}
            label="Comune"
            id="municipality"
            fromDate={dateFilter}
            disabled={!Boolean(dateFilter) || disabled}
            required={required}
          />
        ) : (
          <MunicipalityList
            value={values?.municipality || null}
            onChange={onChangeMunicipalityList}
            label="Comune"
            id="municipality"
            disabled={disabled}
            required={required}
          />
        )}
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="province"
          name="province"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={values?.municipality?.province || ''}
        />
      </Grid>
    </Grid>
  );
};

ItalianComponent.displayName =
  'Form Accordion Registration Citizenship - to DPR component - italian';

const Italian = memo(ItalianComponent);

export default Italian;
